import React from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

/**
 *  Prodigy Styled Select List
 *
 *  Supports Large and Small variants
 *  'p-select' or 'p-select-sml'
 *  defaults to large styling
 */
function ProdigySelect(props) {
  const {
    options,
    placeholder = 'Select...',
    className = 'p-select',
    searchable,
    disabled = false,
    onChange,
    value,
    id,
    height = 26,
  } = props;

  const prodigySelectStyles = {
    control: (provided) => ({
      ...provided,
      height,
      minHeight: height,
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: 12,
      height,
      lineHeight: `${height}px`,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
      height,
      lineHeight: `${height}px`,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height,
      transform: 'none',
      WebkitTransform: 'none',
      cursor: 'pointer',
      position: 'inherit',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
      cursor: 'pointer',
    }),
    input: (provided) => ({
      ...provided,
      height,
      minHeight: height,
      fontSize: 12,
      top: 0,
      transform: 'none',
      WebkitTransform: 'none',
    }),
    menu: (provided) => ({
      ...provided,
      top: height - 6,
    }),
    option: (provided) => ({
      ...provided,
      fontSize: 12,
      cursor: 'pointer',
    }),
  };

  return (
    <ReactSelect
      id={id}
      className={className}
      classNamePrefix="prodigy_select_"
      options={options}
      placeholder={placeholder}
      isSearchable={searchable}
      onChange={onChange}
      value={options.find((o) => isEqual(o.value, value))}
      isDisabled={disabled}
      clearValue={onChange}
      styles={prodigySelectStyles}
    />
  );
}

ProdigySelect.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  searchable: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.any,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  height: PropTypes.number,
};

export default ProdigySelect;
